import React from 'react';
import Image from 'next/image';

import OnlineSafe from '@/assets/icons/online-safe.svg';
import Norton from '@/assets/icons/norton.svg';
import Dol from '@/assets/icons/dol-online.svg';
import SixtAvenue from '@/assets/icons/sixtAvenue.svg';
import Nesine from '@/assets/icons/nesine.svg';
import Kesfet from '@/assets/icons/kesfet.svg';
import BonusCard from '@/assets/icons/BonusCard.svg';
import Maximum from '@/assets/icons/Maximum.svg';
import Yapikredi from '@/assets/icons/yapikredi.svg';
import Ziraat from '@/assets/icons/ziraat.svg';
import Cardfinans from '@/assets/icons/Cardfinans.svg';
import Axess from '@/assets/icons/Axess.svg';
import Advantage from '@/assets/icons/Advantage.svg';
import Paraf from '@/assets/icons/Paraf.svg';
import Visa from '@/assets/icons/Visa.svg';
import Mastercard from '@/assets/icons/Mastercard.svg';
import AmericanExpress from '@/assets/icons/AmericanExpress.svg';

const groupOneSubTwo = [Dol, SixtAvenue, Nesine, Kesfet];
const groupTwoSubOne = [
  BonusCard,
  Maximum,
  Yapikredi,
  Ziraat,
  Cardfinans,
  Axess,
  Advantage,
  Paraf,
  Visa,
  Mastercard,
  AmericanExpress,
];

const Footer: React.FC = () => {
  return (
    <footer>
      <div className='bg-bgGraySecondary max-w-8xl mx-auto'>
        <div className='hidden sm:flex flex-col max-w-max mx-auto md:flex-row gap-5 md:gap-[117.13px] pl-4 md:pl-[120px] pt-[29px] pb-[22px] pr-4 md:pr-[122px] lg:justify-start'>
          <div>
            <div className='flex gap-5 mb-[10px]'>
              <Image src={OnlineSafe} alt='OnlineSafe' />
              <Image src={Norton} alt='Norton' />
            </div>
            <div className='flex gap-3 items-center'>
              {groupOneSubTwo.map((group, i) => (
                <Image src={group} alt='Norton' key={i} />
              ))}
            </div>
          </div>
          <div>
            <div className='flex gap-3 items-center  mb-[10px]'>
              {groupTwoSubOne.map((group, i) => (
                <Image src={group} alt='Norton' key={i} />
              ))}
            </div>
            <div className='text-xs font-normal leading-[21px]'>
              <p className='text-[#424242]'>
                Her şey ayağına gelsin! © Copyright 1998 -{' '}
                {new Date().getFullYear()} D-MARKET Elektronik Hizmetler Tic.
                A.Ş. Her Hakkı Saklıdır.
              </p>
              <p className='text-gray-400'>
                Hepsiburada.com, Bir Doğan Online Markasıdır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
